import { useSnapshot } from "valtio";
import context from "lib/stores/context";
import mapData from "lib/stores/mapData";
import styles from "./DetailsPaneTable.module.scss";
import DetailsPaneTableHeader from "./DetailsPaneTableHeader";
import DetailsPaneTableRow from "./DetailsPaneTableRow";
import DetailsPaneTableHeaderPortal from "./DetailsPaneTableHeaderPortal";
import sortDetailsPaneTableItems from "lib/helpers/sortDetailsPaneTableItems";
import { useEffect, useState } from "react";

const DetailsPaneTable = ({ rows, queryResults }) => {
  const { sortTableBy, sortTableOrder } = useSnapshot(context);
  const { year } = useSnapshot(mapData);
  const [hidden, setHidden] = useState(true);
  const { searchQuery, activeView, activeTabWorldwide, activeTabRegions, activeTabCountries } = useSnapshot(context);

  useEffect(() => {
    if (activeTabWorldwide === 0 || activeTabRegions === 0) {
      setHidden(false);
    } else {
      setHidden(true);
    }
  }, [activeTabWorldwide, activeTabRegions]);

  const renderQueryResults = () => {
    const filteredQueryResults = queryResults.filter(row => {
      if (sortTableBy === "gov resp") {
        return row.gov_resp !== null || row.gov_resp !== undefined || row.gov_resp !== 0;
      }
      if (sortTableBy === "prev") {
        return row.prev !== null || row.prev !== undefined || row.prev !== 0;
      }
      if (sortTableBy === "vuln") {
        return row.vuln !== null || row.vuln !== undefined || row.vuln !== 0;
      }
      return true;
    });
    return filteredQueryResults.sort(sortTableRows).map((row, i) => {
      return <DetailsPaneTableRow data={row} key={i + row.name} />;
    });
  };

  const renderRows = () => {
    if (queryResults.length) return renderQueryResults();
    if (!queryResults.length && searchQuery) {
      return null;
    }
    let nullValues = [];
    if (sortTableBy === "gov resp") {
      nullValues = rows.filter(row => {
        return !row[year].govresponse;
      });
    }
    if (sortTableBy === "prev") {
      nullValues = rows.filter(row => {
        return !row[year].prevalence;
      });
    }
    if (sortTableBy === "vuln") {
      nullValues = rows.filter(row => {
        return !row[year].vulnerability;
      });
    }
    const filteredRows = rows.filter(row => {
      if (sortTableBy === "gov resp") {
        return row[year].govresponse !== 0;
      }
      if (sortTableBy === "prev") {
        return row[year].prevalence !== 0;
      }
      if (sortTableBy === "vuln") {
        return row[year].vulnerability !== 0;
      }
      return true;
    });
    return [...filteredRows.sort(sortTableRows), ...nullValues].map((row, i) => {
      return <DetailsPaneTableRow data={row} key={i + row.name} />;
    });
  };

  const sortTableRows = (a, b) => {
    return sortDetailsPaneTableItems(a, b, sortTableBy, sortTableOrder, year);
  };

  return (
    <table className={`w-full pt-8 h-full transition relative z-10 duration-500 ease-out ${hidden ? "opacity-0 -translate-x-5" : ""}`}>
      <DetailsPaneTableHeader />
      <tbody>{renderRows()}</tbody>
    </table>
  );
};

export default DetailsPaneTable;
